<script>
    export let link;
    export let src;
    export let alt;
</script>

<li class="transition ease-in-out duration-100 transform hover:scale-110">
    <a href={link} target="_blank"><img class="w-5 md:w-6 lg:w-10" {src} {alt}></a>
</li>